export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    useBugsnag().notify(error instanceof Error ? error : new Error(String(error)), {
      severity: 'error',
      context: 'error uncaught',
      metaData: {
        info,
      },
    })
  }
})
